module.exports = __webpack_public_path__ + "static/media/asset_error2.fdcd01a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/asset_error2.svg
// module id = 492
// module chunks = 0